import { render, staticRenderFns } from "./FolderFilterTags.vue?vue&type=template&id=30632c84"
import script from "./FolderFilterTags.vue?vue&type=script&lang=js"
export * from "./FolderFilterTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports